import React, { useEffect, useState } from 'react';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import _ from 'lodash';
import { useAppSelector } from '../../../../infra/hooks';
import { Box } from '@mui/system';
import { Typography } from '@mui/material';
import { fonts, themes } from '../../../themes/themes';
import moment from 'moment';
import './AttendanceCalendar.css';
import Loader from '../../../Lottifiers/Loader/Loader';
import { useTranslation } from 'react-i18next';
import ar from 'date-fns/locale/ar-SA';
import { useTranslate } from '../../../../hooks';

const AttendanceCalendarPresenterData = (prop) => {
  const { t } = useTranslation();
  const trans = t;

  const calendar_data = prop.leaveData;
  const isLoading = useAppSelector(
    (state) => state.dashboardCalendarSlice.dashboardCalendarLoader,
  );
  const [range, setRange] = useState([]);

  const data_leaves = calendar_data.leaves;
  const data_holidays = calendar_data.holidays;
  const data_absent = calendar_data.absents;
  const data_weekoff = calendar_data.weekOffs;

  const handleChange = (_date) => {
    const getMonth = moment(_date).get('month');
    const getYear = moment(_date).get('year');

    prop.handleCalendarChange(getMonth, getYear);
  };

  useEffect(() => {
    const finalData = [];

    // weekoffs
    if (data_weekoff) {
      _.map(data_weekoff, (d) => {
        let weekoff = {
          startDate: new Date(d?.date),
          endDate: new Date(d?.date),
          key: 'selection3',
          color: themes.greyDefault_500,
        };

        finalData.push(weekoff);
      });
    }
    // leaves
    if (data_leaves) {
      _.map(data_leaves, (d) => {
        let leave = {
          startDate: new Date(d?.date),
          endDate: new Date(d?.date),
          key: 'selection0',
          color: themes.leaveCalender,
        };

        finalData.push(leave);
      });
    }

    // holidays
    if (data_holidays) {
      _.map(data_holidays, (d) => {
        let holiday = {
          startDate: new Date(d?.fromDate),
          endDate: new Date(d?.toDate),
          key: 'selection1',
          color: themes.primary,
        };

        finalData.push(holiday);
      });
    }
    // absents
    if (data_absent) {
      _.map(data_absent, (d) => {
        let absent = {
          startDate: new Date(d?.date),
          endDate: new Date(d?.date),
          key: 'selection2',
          color: themes.absentCalender,
        };

        finalData.push(absent);
      });
    }

    setRange(finalData);
  }, [data_leaves, data_absent, data_holidays]);
  // date state

  const { isRTL } = useTranslate();

  return isLoading ? (
    <div style={{ width: '408px' }}>
      <Loader height={100} width={200} />
    </div>
  ) : (
    <div>
      <Box
        style={{
          overflowX: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <DateRange
          ranges={range}
          direction="horizontal"
          showDateDisplay={false}
          locale={isRTL ? ar : undefined}
          onChange={(item) => ''}
          showPreview={false}
          className="Att__calendar"
          onShownDateChange={(DateRange) => handleChange(DateRange)}
          style={{
            width: '100%',
          }}
        />
      </Box>

      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          paddingLeft: '2em',
          paddingRight: '2em',
          justifyContent: 'space-between',
        }}
      >
        <Typography
          style={{
            color: themes.leaveCalender,
            fontFamily: fonts.fontFamily,
            fontSize: fonts.subtitle,
          }}
        >
          {' '}
          {trans('Leaves')}
        </Typography>
        <Typography
          style={{
            color: themes.primary,
            fontFamily: fonts.fontFamily,
            fontSize: fonts.subtitle,
          }}
        >
          {trans('Holiday')}
        </Typography>
        <Typography
          style={{
            color: themes.defaultError,
            fontFamily: fonts.fontFamily,
            fontSize: fonts.subtitle,
          }}
        >
          {' '}
          {trans('Absent')}
        </Typography>
        <Typography
          style={{
            color: themes.greyDefault_500,
            fontFamily: fonts.fontFamily,
            fontSize: fonts.subtitle,
          }}
        >
          {trans('WeekOffs')}
        </Typography>
      </Box>
    </div>
  );
};

export default AttendanceCalendarPresenterData;
